import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Crousel.css';
import vegitable500 from '../images/optimized/vegitable500.webp';
import vegitable1000 from '../images/optimized/vegitable1000.webp';
import vegitable1500 from '../images/optimized/vegitable1500.webp';

import flowers500 from '../images/optimized/flowers500.webp';
import flowers1000 from '../images/optimized/flowers1000.webp';
import flowers1500 from '../images/optimized/flowers1500.webp';

import spices500 from '../images/optimized/spices500.webp';
import spices1000 from '../images/optimized/spices1000.webp';
import spices1500 from '../images/optimized/spices1500.webp';

import garlic500 from '../images/optimized/garlic500.webp';
import garlic1000 from '../images/optimized/garlic1000.webp';
import garlic1500 from '../images/optimized/garlic1500.webp';

import onion500 from '../images/optimized/onion500.webp';
import onion1000 from '../images/optimized/onion1000.webp';
import onion1500 from '../images/optimized/onion1500.webp';

import watermelon500 from '../images/optimized/watermelon500.webp';
import watermelon1000 from '../images/optimized/watermelon1000.webp';
import watermelon1500 from '../images/optimized/watermelon1500.webp';

import mango500 from '../images/optimized/mango500.webp';
import mango1000 from '../images/optimized/mango1000.webp';
import mango1500 from '../images/optimized/mango1500.webp';

import wheatandflour500 from '../images/optimized/wheatandflour500.webp';
import wheatandflour1000 from '../images/optimized/wheatandflour1000.webp';
import wheatandflour1500 from '../images/optimized/wheatandflour1500.webp';

import rice500 from '../images/optimized/rice500.webp';
import rice1000 from '../images/optimized/rice1000.webp';
import rice1500 from '../images/optimized/rice1500.webp';

import papaya500 from '../images/optimized/papaya500.webp';
import papaya1000 from '../images/optimized/papaya1000.webp';
import papaya1500 from '../images/optimized/papaya1500.webp';

import potato500 from '../images/optimized/potato500.webp';
import potato1000 from '../images/optimized/potato1000.webp';
import potato1500 from '../images/optimized/potato1500.webp';

import greenandredchillies500 from '../images/optimized/greenandredchillies500.webp';
import greenandredchillies1000 from '../images/optimized/greenandredchillies1000.webp';
import greenandredchillies1500 from '../images/optimized/greenandredchillies1500.webp';

import mustard500 from '../images/optimized/mustard500.webp';
import mustard1000 from '../images/optimized/mustard1000.webp';
import mustard1500 from '../images/optimized/mustard1500.webp';

import gooseberry500 from '../images/optimized/gooseberry500.webp';
import gooseberry1000 from '../images/optimized/gooseberry1000.webp';
import gooseberry1500 from '../images/optimized/gooseberry1500.webp';

import gram500 from '../images/optimized/gram500.webp';
import gram1000 from '../images/optimized/gram1000.webp';
import gram1500 from '../images/optimized/gram1500.webp';

import ginger500 from '../images/optimized/ginger500.webp';
import ginger1000 from '../images/optimized/ginger1000.webp';
import ginger1500 from '../images/optimized/ginger1500.webp';

import foxnut500 from '../images/optimized/foxnut500.webp';
import foxnut1000 from '../images/optimized/foxnut1000.webp';
import foxnut1500 from '../images/optimized/foxnut1500.webp';

const slides = [
    {
        id: "vegetables-main",
        images: {
            small: vegitable500,
            medium: vegitable1000,
            large: vegitable1500
        },
        title: "Vegetables & Foodstuffs for Global Export",
        subtitle: "Drumstick, Fenugreek & Mint Leaves",
        alt: "Certified Indian organic vegetables for export - Beetroot (चुकंदर), Drumstick/Moringa (सहजन), Sweet Potatoes (शकरकंद), Fenugreek Leaves (मेथी), Mint Leaves (पुदीना), Cardamom Leaves (इलायची पत्ते)"
    },
    {
        id: "flowers-main",
        images: {
            small: flowers500,
            medium: flowers1000,
            large: flowers1500
        },
        title: "Premium Cut & Uncut Flowers from India",
        subtitle: "Orchids, Tuberose, Marigolds, Carnations",
        alt: "Indian flower export - Fresh Carnations (गुलदाउदी), Lilies (लिली), Gerberas (गर्बेरा), Chrysanthemums (गुलदाउदी), Orchids (ऑर्किड), Tuberose (रजनीगंधा), Marigolds (गेंदा) for weddings/events"
    },
    {
        id: "spices-mix",
        images: {
            small: spices500,
            medium: spices1000,
            large: spices1500
        },
        title: "Premium Indian Spices for Global Export",
        subtitle: "Organic Turmeric, Cardamom & Black Pepper",
        alt: "Certified Indian organic spices for export - Turmeric (हल्दी), Cardamom (इलायची), Black Pepper (काली मिर्च), Cumin (जीरा), Coriander (धनिया), Fenugreek (मेथी)"
    },
    {
        id: "garlic-main",
        images: {
            small: garlic500,
            medium: garlic1000,
            large: garlic1500
        },
        title: "Fresh Indian Garlic",
        subtitle: "High-quality white garlic bulbs from India",
        alt: "Export-grade fresh Indian garlic - wholesale supplier of dehydrated and raw garlic bulbs"
    },
    {
        id: "onion-main",
        images: {
            small: onion500,
            medium: onion1000,
            large: onion1500
        },
        title: "Indian Onion Export - Red & White Varieties",
        subtitle: "Indian red onions and white onions",
        alt: "Wholesale onion exporter from India - red onions, white onions for GCC, EU & Asian buyers"
    },
    {
        id: "watermelon-main",
        images: {
            small: watermelon500,
            medium: watermelon1000,
            large: watermelon1500
        },
        title: "Watermelon Export from India",
        subtitle: "Fresh seedless and hybrid watermelons",
        alt: "Export-quality Indian watermelons - sweet, juicy, and farm-fresh for global markets"
    },
    {
        id: "mango-main",
        images: {
            small: mango500,
            medium: mango1000,
            large: mango1500
        },
        title: "Premium Indian Mangoes for Export ",
        subtitle: "Alphonso, Kesar Banganapalli ..",
        alt: "Fresh Indian mangoes for international buyers - Alphonso, Kesar and more varieties for air and sea export"
    },
    {
        id: "wheat-flour-main",
        images: {
            small: wheatandflour500,
            medium: wheatandflour1000,
            large: wheatandflour1500
        },
        title: "Premium Wheat & Flour from India",
        subtitle: "Best Quality Indian Wheat Grains & Flours",
        alt: "Indian Wheat (गेहूं) export - Premium Wheat Flour (आटा), Maida (मैदा), Suji (सूजी), Durum Wheat, Sharbati Wheat, MP Wheat for global buyers"
    },
    {
        id: "rice-main",
        images: {
            small: rice500,
            medium: rice1000,
            large: rice1500
        },
        title: "Basmati & Non-Basmati Rice",
        subtitle: "Long-grain, aromatic rice varieties",
        alt: "Export-quality basmati rice supplier from India"
    },
    {
        id: "papaya-main",
        images: {
            small: papaya500,
            medium: papaya1000,
            large: papaya1500
        },
        title: "Fresh Organic Papaya",
        subtitle: "Fresh Indian papaya - Delicious and healthy",
        alt: "Indian papaya export - top tropical fruit supplier"
    },
    {
        id: "potato-main",
        images: {
            small: potato500,
            medium: potato1000,
            large: potato1500
        },
        title: "High-Grade Indian Potatoes",
        subtitle: "Best-in-class potatoes",
        alt: "Premium Indian potato exporter for international"
    },
    {
        id: "chillies-main",
        images: {
            small: greenandredchillies500,
            medium: greenandredchillies1000,
            large: greenandredchillies1500
        },
        title: "Green & Red Chillies",
        subtitle: "Spicy, farm-fresh chillies",
        alt: "Chilli exporter from India - red and green varieties"
    },
    {
        id: "mustard-oil-main",
        images: {
            small: mustard500,
            medium: mustard1000,
            large: mustard1500
        },
        title: "Cold-Pressed Mustard Oil",
        subtitle: "Pure mustard and mustard oil",
        alt: "Mustard and mustard oil exporter from India"
    },
    {
        id: "gooseberry-main",
        images: {
            small: gooseberry500,
            medium: gooseberry1000,
            large: gooseberry1500
        },
        title: "Fresh Amla (Gooseberry) Exports",
        subtitle: "High-vitamin Indian gooseberries",
        alt: "Global exporter of Indian amla (gooseberry) rich in Vitamin C"
    },
    {
        id: "gram-main",
        images: {
            small: gram500,
            medium: gram1000,
            large: gram1500
        },
        title: "Export Grade Whole Gram",
        subtitle: "High-protein pulses",
        alt: "Leading global supplier of Indian gram and pulses"
    },
    {
        id: "ginger-main",
        images: {
            small: ginger500,
            medium: ginger1000,
            large: ginger1500
        },
        title: "Organic Fresh Ginger",
        subtitle: "Aromatic Indian ginger",
        alt: "Premium ginger exports from India – Shri Gwal Exim"
    },
    {
        id: "foxnut-main",
        images: {
            small: foxnut500,
            medium: foxnut1000,
            large: foxnut1500
        },
        title: "Premium Quality Makhana (Foxnut)",
        subtitle: "Foxnuts for healthy snacking",
        alt: "Global supplier of Indian foxnut (makhana) for healthy snacking"
    },
    {
        id: "spices-main",
        images: {
            small: spices500,
            medium: spices1000,
            large: spices1500
        },
        title: "Indian Organic Spices Export",
        subtitle: "Indian spices - turmeric, chili, cumin",
        alt: "Real Indian spices exporter - organic turmeric, cumin, coriander, and masalas for global import"
    }
];

const Crousel = () => {
    const settings = {
        dots: true,
        infinite: true,
        initialSlide: 0,
        lazyLoad: "ondemand", // ⬅️ Only loads when needed
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        touchMove: true,
        pauseOnHover: true,
        arrows: false,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    };


    return (
        <section
            className="carousel-section shadow overflow-hidden"
            aria-label="Global Export Product Showcase"
            itemScope
            itemType="https://schema.org/ItemList"
            style={{ padding: 0, margin: 0 }}
        >
            <Slider {...settings}>
                {slides.map((slide, index) => (
                    <div
                        className="slide-container"
                        key={slide.id}
                        itemScope
                        itemProp="itemListElement"
                        itemType="https://schema.org/ListItem"
                    >
                        <picture>
                            <source
                                media="(max-width: 500px)"
                                srcSet={slide.images.small}
                            />
                            <source
                                media="(max-width: 1000px)"
                                srcSet={slide.images.medium}
                            />
                            <img
                                src={slide.images.large}
                                srcSet={`${slide.images.small} 500w, ${slide.images.medium} 1000w, ${slide.images.large} 1500w`}
                                sizes="(max-width: 500px) 100vw, (max-width: 1000px) 100vw, 100vw"
                                alt={slide.alt}
                                className="slide-image"
                                loading={index <= 2 ? "eager" : "lazy"}
                                fetchPriority={index <= 1 ? "high" : "auto"}

                                width="1500"
                                height="844"
                                itemProp="image"
                                decoding="async"
                            />
                        </picture>
                        <div className="overlay-content">
                            <h6 className="overlay-title" itemProp="name">{slide.title}</h6>
                            {slide.subtitle && (
                                <p className="overlay-subtitle" itemProp="description">
                                    {slide.subtitle}
                                </p>
                            )}
                        </div>
                        <meta itemProp="position" content={index + 1} />
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default Crousel;